import apiClient from "./apiClient";
export { uploadImage } from './products';

export const submitWarrantyClaim = async (claimData) => {
  const formData = new FormData();
  for (const key of ['name', 'email', 'order_number', 'purchase_date', 'germination_date', 'product_name', 'description']) {
    formData.append(key, claimData[key] || '');
  }
  (claimData.photos || []).filter(Boolean).slice(0, 3).forEach(file => formData.append('photos[]', file));
  const response = await apiClient.post('/warranty-claims/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getEligibleWarrantyOrders = async () => {
  try {
    const token = localStorage.getItem("accessToken");
    if (!token) throw new Error('Usuario no autenticado');
    
    const response = await apiClient.get("/orders/my-orders/");
    console.log('Eligible orders response:', response.data);
    
    // Handle paginated response - extract results array
    let ordersData;
    if (response.data && response.data.results) {
      ordersData = response.data.results;
    } else if (response.data && response.data.orders) {
      ordersData = response.data.orders;
    } else if (Array.isArray(response.data)) {
      ordersData = response.data;
    } else {
      ordersData = [];
    }
    
    // Filtrar pedidos completados de los últimos 90 días
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
    
    const eligibleOrders = ordersData.filter(order => 
      order.status === 'completed' && new Date(order.created_at) > ninetyDaysAgo
    );
    
    console.log('Eligible orders filtered:', eligibleOrders.length);
    return { orders: eligibleOrders };
  } catch (error) {
    console.error('Error fetching eligible orders:', error);
    throw error;
  }
};

export const getWarrantyClaims = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No hay sesión activa');
    }

    // Usar el filtro user con el endpoint estándar para obtener solo las reclamaciones del usuario actual
    const response = await apiClient.get("/warranty-claims/?user=current", {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    console.log('Warranty claims response:', response.data);
    
    // Handle paginated response - extract results array
    if (response.data && response.data.results) {
      return response.data.results;
    } else if (Array.isArray(response.data)) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching warranty claims:', error);
    if (error.response?.status === 403 || error.response?.status === 401) {
      throw new Error('No tienes permisos para ver las solicitudes de garantía');
    }
    throw new Error('Error al cargar las solicitudes de garantía');
  }
};

export const updateWarrantyClaim = async (claimId, updateData) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No hay sesión activa');
    }

    console.log('Sending update with data:', updateData); // Debug log

    const response = await apiClient.patch(`/warranty-claims/${claimId}/`, updateData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    console.log('Server response:', response.data); // Debug log

    if (!response.data) {
      throw new Error('No se recibió respuesta del servidor');
    }

    return response.data;
  } catch (error) {
    console.error('Error updating warranty claim:', error.response || error);
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error(error.message || 'Error al actualizar el reclamo');
  }
};

export const createWarrantyClaim = async (formData) => {
  try {
    const token = localStorage.getItem('accessToken');
    
    console.log('Creating warranty claim with data:', formData);
    
    // Set up the request with auth token if available
    const requestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...(token && { 'Authorization': `Bearer ${token}` })
      }
    };
    
    // If user is authenticated, let the backend get user info from token
    if (token) {
      // Add a flag for backend to use authenticated user info
      formData.use_authenticated_user = true;
    }
    
    const response = await apiClient.post("/warranty-claims/", formData, requestConfig);
    
    console.log('Warranty claim created:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating warranty claim:', error);
    throw new Error(error.response?.data?.error || error.response?.data?.message || 'Error al crear el reclamo de garantía');
  }
};
